import { Image } from "antd";
import styled from "styled-components";

export const StyledWidgetGalleryWrapper = styled.div`
	&.grid {
		width: 100%;
		display: grid;
		grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
		gap: 2px;
	}
`;

export const StyledMediaBox = styled.div`
	width: 100%;
	position: relative;
	aspect-ratio: 1;
	overflow: hidden;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	${({ aspectRatio }) => aspectRatio && `aspect-ratio: ${aspectRatio}`};

	img {
		object-fit: cover;
		border-radius: 2px;
	}

	.absolute {
		position: absolute;
		top: 0;
		left: 0;
	}
`;

export const StyledAnimatedGalleryWrapper = styled.div`
	overflow: hidden;
	width: 100%;
	height: 100%;
	margin: auto;
	position: relative;
`;

export const StyledAnimatedGallery = styled.div`
	--maxScale: ${({ isMobile }) => (isMobile ? 0.54 : 0.64)};
	--minScale: ${({ isMobile }) => (isMobile ? 0.25 : 0.3)};

	@keyframes zoomOut {
		0% {
			transform-origin: center center;
			transform: scale(var(--maxScale));
		}

		50% {
			transform-origin: center center;
			transform: scale(var(--minScale));
		}

		100% {
			transform-origin: center center;
			transform: scale(var(--maxScale));
		}
	}

	position: absolute;
	margin: auto;

	width: 2400px;
	left: -960px;
	top: -1400px;

	animation-name: zoomOut;
	transform: scale(0.64);
	transform-origin: center center;
	animation-duration: 10s;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
`;

export const StyledAnimatedGalleryItem = styled.div`
	width: 400px;
	float: left;

	@keyframes clockwise {
		0% {
			left: 0;
			top: 0;
		}
		5% {
			left: 0;
			top: 0;
		}

		20% {
			left: -200px;
			top: 0;
		}
		30% {
			left: -200px;
			top: 0;
		}

		45% {
			left: -200px;
			top: -400px;
		}
		55% {
			left: -200px;
			top: -400px;
		}

		70% {
			left: 0;
			top: -400px;
		}
		80% {
			left: 0;
			top: -400px;
		}

		95% {
			left: 0;
			top: 0;
		}
		100% {
			left: 0;
			top: 0;
		}
	}

	@keyframes counterClockwise {
		0% {
			left: -200px;
			top: -400px;
		}
		5% {
			left: -200px;
			top: -400px;
		}

		20% {
			left: 0;
			top: -400px;
		}
		30% {
			left: 0;
			top: -400px;
		}

		45% {
			left: 0;
			top: 0;
		}
		55% {
			left: 0;
			top: 0;
		}

		70% {
			left: -200px;
			top: 0;
		}
		80% {
			left: -200px;
			top: 0;
		}

		95% {
			left: -200px;
			top: -400px;
		}
		100% {
			left: -200px;
			top: -400px;
		}
	}

	.image-holder {
		position: relative;
		width: 200px;
		height: 400px;
		margin: auto;
		overflow: hidden;
		float: left;

		.images {
			width: 400px;
			height: 800px;
			position: relative;
			animation-duration: 7.5s; // Time to rotate
			animation-iteration-count: infinite;
			animation-timing-function: ease-out;
			animation-delay: 3s;

			img {
				width: 200px;
				height: 400px;
				object-fit: cover;
			}
		}

		.clockwise {
			animation-name: clockwise;
			left: 0;
			top: 0;
		}

		.counterClockwise {
			animation-name: counterClockwise;
			left: -200px;
			top: -400px;
		}
	}
`;
